import { Table, TableBody, TableContainer } from '@mui/material';
import React from 'react';
import Scrollbar from '../../layout/scrollbar';
import TableHeader from './table-header';

interface TableContentProps {
  tableHeaders?: any[];
  rowRenderer?: React.ReactNode;
  handleSortRequest?: (column: string) => void;
  filters?: any;
}

export default function TableContent({
  tableHeaders,
  rowRenderer,
  handleSortRequest,
  filters,
}: TableContentProps) {
  return (
    <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
      <Scrollbar>
        <Table sx={{ minWidth: '1000px' }} stickyHeader aria-label="sticky table">
          <TableHeader
            tableHeaders={tableHeaders}
            handleSortRequest={handleSortRequest}
            filters={filters}
          />
          <TableBody>{rowRenderer}</TableBody>
        </Table>
      </Scrollbar>
    </TableContainer>
  );
}
